import styled from 'styled-components'

interface ContainerProps {
  height?: string;
  hideTextOnSmallMobile?: boolean;
  layoutOnMobile?: 'column' | 'row';
}

interface CardTitleProps {
  hideTextOnSmallMobile?: boolean;
}

interface CardDescriptionProps {
  hideTextOnSmallMobile?: boolean;
}

interface CardInfoContainerProps {
  hideTextOnSmallMobile?: boolean;
}

export const Container = styled.div<ContainerProps>`
  height: ${(props) => props.height || '200px'};
  width: 100%;
  background-color: rgba(255, 255, 255, 0.02);
  border-radius: 8px;
  border: 0.5px solid #4B5563;
  background: #242738;
  box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.10), 0px 4px 6px -2px rgba(0, 0, 0, 0.05);
  padding: 24px;

  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 40px;
  position: relative;
  z-index: 490;

  @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.md} {
    height: auto;
    padding: 32px;

    ${(props) => props.layoutOnMobile === 'column' && `
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
      gap: 24px;
    `}
  }

  @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.sm} {
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 24px;
    padding: 24px;

    ${(props) => props.hideTextOnSmallMobile && `
      gap: 16px;
      align-items: center;
      justify-content: center;
      text-align: center;
    `}
  }
`

export const CardImage = styled.div`
  width: 64px;
  height: 64px;

  img,
  svg {
    aspect-ratio: 1/1;
    width: fit-content;
    height: 100%;
  }

  @media ${(props) =>
      props.theme.breakpoints && props.theme.breakpoints.sm} {
    width: 48px;
    height: 48px;
  }
`

export const CardInfoContainer = styled.div<CardInfoContainerProps>`
  display: flex;
  flex-direction: column;
  flex-grow: 1;

  @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.md} {
     width: 100%;
  }

  @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.sm} {
    ${(props) => props.hideTextOnSmallMobile && `
      align-items: center;
      justify-content: center;
      margin-bottom: 0px;
    `}
  }
`

export const CardTitle = styled.div<CardTitleProps>`
  font-family: everettmedium;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 1.55;
  color: #fff;
  word-wrap: break-word;
  display: flex;
  letter-spacing: -0.05px;
  margin-bottom: 12px;

  @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.sm} {
    margin-bottom: 8px;

    ${(props) => props.hideTextOnSmallMobile && `
      margin-bottom: 0px;
    `}
  }
`

export const CardDescription = styled.div<CardDescriptionProps>`
  color: #e8ebfb;
  font-family: "Inter";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 1.42;
  letter-spacing: 0.16px;
  overflow-wrap: break-word;

  @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.sm} {
    font-size: 16px;
    line-height: 1.5;

    ${(props) => props.hideTextOnSmallMobile && `
      display: none;
    `}
  }

`

export const AdditionalMessage = styled.div`
  width: 50px;
  height: 19px;
  background: rgba(255, 204, 0, 0.06);
  border-radius: 10px;

  display: flex;
  justify-content: center;
  align-items: center;

  margin-left: 10px;

  span {
    color: #ffcc00;
    font-family: "Inter";
    font-style: normal;
    font-weight: bold;
    font-size: 10px;
    line-height: 30px;
    letter-spacing: 0.08em;
  }
`
